import { Injectable } from '@angular/core';
import { MsalService } from '@azure/msal-angular';
import {
  PipelinePolicy,
  PipelineRequest,
  PipelineResponse,
  SendRequest,
} from '@azure/core-rest-pipeline';
import {
  AccountInfo,
  AuthenticationResult,
  InteractionRequiredAuthError,
} from '@azure/msal-browser';
import { Observable, of } from 'rxjs';
import { catchError, map, switchMap, take } from 'rxjs/operators';
import { silentGetLoginTokenRequest } from '@nx-ng/b2c/b2c-config';
import { B2CEventsService } from '@nx-ng/b2c/b2c-events.service';

const BEARER_TOKEN_NAME = 'openIDToken';

@Injectable({ providedIn: 'root' })
export class MsalPolicyService {
  constructor(
    private msalService: MsalService,
    private b2CEventsService: B2CEventsService
  ) {}

  token$: Observable<string | undefined> =
    this.b2CEventsService.activeAccount$.pipe(
      switchMap((activeAccount?: AccountInfo) => {
        const request = silentGetLoginTokenRequest;
        if (activeAccount) {
          request.account = activeAccount;
        }

        return this.msalService.acquireTokenSilent(request).pipe(
          map((response: AuthenticationResult) => {
            return response.idToken;
          }),
          catchError((error) => {
            console.log(
              'An error has occurred when trying to acquire token: ',
              error
            );
            if (
              error instanceof InteractionRequiredAuthError &&
              activeAccount
            ) {
              this.msalService.acquireTokenRedirect(request);
            }
            return of(undefined);
          })
        );
      })
    );

  buildPipelinePolicy(): PipelinePolicy {
    return {
      name: 'interceptPolicyForMsal',
      sendRequest: async (
        request: PipelineRequest,
        next: SendRequest
      ): Promise<PipelineResponse> => {
        const token = await this.token$.pipe(take(1)).toPromise();
        if (token) {
          request.headers.set(BEARER_TOKEN_NAME, token);
        }
        return next(request);
      },
    };
  }
}
